module.exports = __webpack_public_path__ + "static/logo-big-0702e123db4f86b5be46c2fa318adaf6.png";